(function () {

  function initCustomHeroSlider(slider) {

    if (!slider) {
      return;
    }

    if (slider.dataset.initialized === 'true') {
      return;
    }

    slider.dataset.initialized = 'true';


    const slides = Array.from(
      slider.querySelectorAll('.custom-hero-slider__slide')
    );

    const dots = Array.from(
      slider.querySelectorAll('.custom-hero-slider__dot')
    );

    const track = slider.querySelector(
      '.custom-hero-slider__track'
    );


    if (slides.length === 0) {
      return;
    }


    let currentSlide = 0;

    let autoplayTimer = null;

    let touchStartX = 0;
    let touchEndX = 0;

    let mouseStartX = 0;
    let mouseCurrentX = 0;

    let isMouseDragging = false;
    let didDrag = false;


    const autoplay =
      slider.dataset.autoplay === 'true';


    const autoplaySpeed =
      parseInt(
        slider.dataset.autoplaySpeed,
        10
      ) || 5000;


    /* =========================================
       SHOW SLIDE
       ========================================= */

    function showSlide(index) {

      if (index < 0) {
        index = slides.length - 1;
      }

      if (index >= slides.length) {
        index = 0;
      }

      currentSlide = index;


      slides.forEach(function (slide, i) {

        slide.classList.toggle(
          'is-active',
          i === currentSlide
        );

      });


      dots.forEach(function (dot, i) {

        const isActive =
          i === currentSlide;

        dot.classList.toggle(
          'is-active',
          isActive
        );

        dot.setAttribute(
          'aria-selected',
          isActive ? 'true' : 'false'
        );

      });

    }


    /* =========================================
       NEXT
       ========================================= */

    function nextSlide() {

      showSlide(
        currentSlide + 1
      );

    }


    /* =========================================
       PREVIOUS
       ========================================= */

    function previousSlide() {

      showSlide(
        currentSlide - 1
      );

    }


    /* =========================================
       AUTOPLAY
       ========================================= */

    function stopAutoplay() {

      if (autoplayTimer !== null) {

        clearInterval(
          autoplayTimer
        );

        autoplayTimer = null;

      }

    }


    function startAutoplay() {

      stopAutoplay();


      if (
        !autoplay ||
        slides.length <= 1
      ) {
        return;
      }


      autoplayTimer = setInterval(
        function () {

          nextSlide();

        },
        autoplaySpeed
      );

    }


    /* =========================================
       DOTS
       ========================================= */

    dots.forEach(function (dot) {

      dot.addEventListener(
        'click',
        function (event) {

          event.preventDefault();

          const index =
            parseInt(
              dot.dataset.slide,
              10
            );


          if (
            Number.isNaN(index)
          ) {
            return;
          }


          showSlide(index);

          startAutoplay();

        }
      );

    });


    /* =========================================
       MOBILE TOUCH SWIPE
       ========================================= */

    if (track) {

      track.addEventListener(
        'touchstart',
        function (event) {

          if (
            !event.touches ||
            !event.touches.length
          ) {
            return;
          }


          touchStartX =
            event.touches[0].clientX;

          touchEndX =
            touchStartX;

        },
        {
          passive: true
        }
      );


      track.addEventListener(
        'touchmove',
        function (event) {

          if (
            !event.touches ||
            !event.touches.length
          ) {
            return;
          }


          touchEndX =
            event.touches[0].clientX;

        },
        {
          passive: true
        }
      );


      track.addEventListener(
        'touchend',
        function () {

          const swipeDistance =
            touchStartX - touchEndX;


          const minimumSwipeDistance =
            50;


          if (
            Math.abs(swipeDistance) <
            minimumSwipeDistance
          ) {
            return;
          }


          if (
            swipeDistance > 0
          ) {

            nextSlide();

          } else {

            previousSlide();

          }


          startAutoplay();

        }
      );


      /* =========================================
         DESKTOP MOUSE DRAG
         ========================================= */

      track.addEventListener(
        'mousedown',
        function (event) {

          /*
           * Only respond to the LEFT mouse button.
           */

          if (event.button !== 0) {
            return;
          }


          isMouseDragging = true;
          didDrag = false;

          mouseStartX =
            event.clientX;

          mouseCurrentX =
            event.clientX;


          track.classList.add(
            'is-dragging'
          );


          stopAutoplay();


          /*
           * Prevent the browser from
           * selecting/dragging the image.
           */

          event.preventDefault();

        }
      );


      document.addEventListener(
        'mousemove',
        function (event) {

          if (!isMouseDragging) {
            return;
          }


          mouseCurrentX =
            event.clientX;


          const distance =
            mouseStartX -
            mouseCurrentX;


          if (
            Math.abs(distance) > 5
          ) {
            didDrag = true;
          }

        }
      );


      document.addEventListener(
        'mouseup',
        function () {

          if (!isMouseDragging) {
            return;
          }


          const distance =
            mouseStartX -
            mouseCurrentX;


          const minimumDragDistance =
            60;


          isMouseDragging = false;


          track.classList.remove(
            'is-dragging'
          );


          if (
            Math.abs(distance) >=
            minimumDragDistance
          ) {

            if (distance > 0) {

              nextSlide();

            } else {

              previousSlide();

            }

          }


          startAutoplay();

        }
      );


      /*
       * If the mouse leaves the browser window
       * while dragging, safely reset the drag.
       */

      document.addEventListener(
        'mouseleave',
        function () {

          if (!isMouseDragging) {
            return;
          }


          isMouseDragging = false;


          track.classList.remove(
            'is-dragging'
          );


          startAutoplay();

        }
      );


      /*
       * Prevent accidental link opening after
       * the user actually dragged the banner.
       */

      track.addEventListener(
        'click',
        function (event) {

          if (didDrag) {

            event.preventDefault();

            event.stopPropagation();

            didDrag = false;

          }

        },
        true
      );

    }


    /* =========================================
       PAUSE AUTOPLAY ON HOVER
       ========================================= */

    slider.addEventListener(
      'mouseenter',
      function () {

        if (!isMouseDragging) {
          stopAutoplay();
        }

      }
    );


    slider.addEventListener(
      'mouseleave',
      function () {

        if (!isMouseDragging) {
          startAutoplay();
        }

      }
    );


    /* =========================================
       INITIALIZE
       ========================================= */

    showSlide(0);

    startAutoplay();

  }


  /* =========================================
     INITIALIZE ALL SLIDERS
     ========================================= */

  function initializeSliders() {

    const sliders =
      document.querySelectorAll(
        '.custom-hero-slider'
      );


    sliders.forEach(function (slider) {

      initCustomHeroSlider(slider);

    });

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeSliders
    );

  } else {

    initializeSliders();

  }


  /* =========================================
     SHOPIFY THEME EDITOR SUPPORT
     ========================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      if (!event.target) {
        return;
      }


      const slider =
        event.target.querySelector(
          '.custom-hero-slider'
        );


      if (slider) {

        initCustomHeroSlider(
          slider
        );

      }

    }
  );


  document.addEventListener(
    'shopify:section:unload',
    function (event) {

      if (!event.target) {
        return;
      }


      const slider =
        event.target.querySelector(
          '.custom-hero-slider'
        );


      if (slider) {

        slider.dataset.initialized =
          'false';

      }

    }
  );

})();